<template>
    <legend>Результат</legend>
    
    <section>
        <h5 class="text-success fw-bold fst-italic mb-2">Переможці</h5>
        <BTable
            :items="winners"
            :fields="fields"
            bordered
            head-variant="light"
            class="mb-4"
            :tbody-tr-class="() => 'table-success'"
        >
            <template #cell(company)="ctx">
                <a :href="`/kontrahenty/${ctx.item.author_id}`" target="_blank">
                    {{ ctx.item.company }}
                </a>
            </template>
            <template #cell(price)="ctx">
                <span v-if="ctx.item.price">{{ ctx.item.price }}</span>
                <span v-else class="text-muted">—</span>
            </template>
            <template #cell(total)="ctx">
                <span v-if="ctx.item.total">{{ ctx.item.total }}</span>
                <span v-else class="text-muted">—</span>
            </template>
            <template #cell(terms)="ctx">
                <span v-if="ctx.item.terms">{{ ctx.item.terms }}</span>
                <span v-else class="text-muted">—</span>
            </template>
            <template #cell(payment)="ctx">
                <span v-if="ctx.item.payment">{{ ctx.item.payment }}</span>
                <span v-else class="text-muted">—</span>
            </template>
        </BTable>
        
        <h5 class="text-danger fw-bold fst-italic mb-2">Інші заявки</h5>
        <BTable
            :items="others"
            :fields="fields"
            bordered
            head-variant="light"
        >
            <template #cell(company)="ctx">
                <a :href="`/kontrahenty/${ctx.item.author_id}`" target="_blank">
                    {{ ctx.item.company }}
                </a>
            </template>
            <template #cell(price)="ctx">
                <span v-if="ctx.item.price">{{ ctx.item.price }}</span>
                <span v-else class="text-muted">—</span>
            </template>
            <template #cell(total)="ctx">
                <span v-if="ctx.item.total">{{ ctx.item.total }}</span>
                <span v-else class="text-muted">—</span>
            </template>
            <template #cell(terms)="ctx">
                <span v-if="ctx.item.terms">{{ ctx.item.terms }}</span>
                <span v-else class="text-muted">—</span>
            </template>
            <template #cell(payment)="ctx">
                <span v-if="ctx.item.payment">{{ ctx.item.payment }}</span>
                <span v-else class="text-muted">—</span>
            </template>
        </BTable>
    </section>
</template>

<script>
import {
    BButton,
    BTable,
    BOverlay,
    BTooltip,
} from 'bootstrap-vue-next';

export default {
    name: "protocol_inside_winners_down",
    props: { protocol: { type: Object, required: true } },
    
    components : {
        BTable,
    },
    
    computed: {
        fields() {
            return [
                { key: 'company', label: 'Компанія' },
                { key: 'edrpou',  label: 'ЄДРПОУ', class: 'text-nowrap' },
                { key: 'price',   label: 'Ціна за од.', class: 'text-' },
                { key: 'total',   label: 'Сума пропозиції', class: 'text-' },
                { key: 'terms',   label: 'Строк поставки', class: 'text-nowrap' },
                { key: 'payment', label: 'Умови оплати',   class: 'text-nowrap' },
            ]
        },
        
        appsByAuthor() {
            const map = {}
            const apps = this.protocol?.applications_info || []
            apps.forEach(a => { map[String(a.author_id)] = a })
            return map
        },
        
        rows() {
            const members = this.protocol?.members || []
            return members.map(m => {
                const app = this.appsByAuthor[String(m.author_id)] || {}
                return {
                    author_id: m.author_id,
                    company: m.company,
                    edrpou: app.edrpou || '',
                    price: this.strip(app.priceprop),
                    total: this.strip(app.summprop),
                    terms: app.datedeliveryinfo || '',
                    payment: this.strip(app.paymentinfo),
                    is_winner: !!m.is_winner,
                }
            })
        },
        
        winners() { return this.rows.filter(r => r.is_winner) },
        others()  { return this.rows.filter(r => !r.is_winner) },
    },
    
    methods: {
        strip(html) {
            if (!html) return ''
            return String(html).replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim()
        },
    },
}
</script>

<style scoped>
/* при желании: мелкая косметика */
</style>
